export interface EnqueueJobSkippedItem {
    entityId: string
    refNo?: string
    reason: string
}

export interface EnqueueJobResponseData {
    batchId: string
    queuedCount: number
    skipped: EnqueueJobSkippedItem[]
}

export interface EnqueueJobResponse {
    isSuccess: boolean
    message: string
    data: EnqueueJobResponseData
}

export interface JobQueueBatchStatus {
    batchId: string
    jobType?: string
    jobTypeName?: string
    total: number
    waiting: number
    running: number
    succeeded: number
    failed: number
    cancelled: number
    isCompleted: boolean
}

export interface GetJobQueueBatchStatusResponse {
    isSuccess: boolean
    message: string
    data: JobQueueBatchStatus[]
}

export interface GetJobQueueListPagingAndFilterResponseItem {
    jobQueueId: string
    batchId: string
    jobType: string
    jobTypeName: string
    entityId?: string
    entityRefNo?: string
    status: number
    statusName: string
    attemptCount: number
    maxAttempts: number
    resultMessage?: string
    createdDateStr?: string
    startedDateStr?: string
    finishedDateStr?: string
    nextRunAtStr?: string
    createdUser?: string
    isSelected: boolean
}

export interface GetJobQueueListPagingAndFilterResponseData {
    items: GetJobQueueListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export const initialGetJobQueueListPagingAndFilterResponseData: GetJobQueueListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}

export interface GetJobQueueListPagingAndFilterResponse {
    isSuccess: boolean
    message: string
    data: GetJobQueueListPagingAndFilterResponseData
}

export interface JobQueueCountResponse {
    isSuccess: boolean
    message: string
    data: number
}

/** Durum kodları (sunucudaki JobQueueStatus ile aynı). */
export const JOB_QUEUE_STATUS = {
    BEKLIYOR: 0,
    CALISIYOR: 1,
    BASARILI: 2,
    HATALI: 3,
    IPTAL: 4,
}
